import React, { useState } from "react";
import ActionButton from "../../../components/Buttons/ActionButton";
import NavigationButton from "../../../components/Buttons/NavigationButton";
import { ReactComponent as ArrowLeftIcon } from "../../../assets/icons/arrow_left.svg";
import { ReactComponent as SaveIcon } from "../../../assets/icons/save.svg";
import { ReactComponent as UndoIcon } from "../../../assets/icons/undo.svg";
import { ReactComponent as RedoIcon } from "../../../assets/icons/redo.svg";
import useUndoableState from "../../../hooks/useUndoableState";

type ActionSidebarProps = {
  action?: any;
  onSave?: any;
  code?: any;
  undo?: any;
  redo?: any;
};

const ActionSidebar = (props: ActionSidebarProps) => {
  const [action, setAction] = useState(props.action);

  return (
    <div className="action-sidebar">
      <div className="action-title">
        <div className="action-title-content">
          <NavigationButton
            className="back-btn"
            icon={<ArrowLeftIcon />}
            to="/develop/actions"
          />
          {props.action && (
            <div>
              <div style={{ marginBottom: ".2rem" }}>{props.action.name}</div>
              <span
                style={{
                  fontSize: "12px",
                  fontWeight: "500",
                  display: "flex",
                  marginBottom: ".2rem",
                }}
              >
                <div style={{ marginRight: ".2rem" }}>Action type:</div>
                <div style={{ fontWeight: "300" }}>
                  {props.action.actionTypes && props.action.actionTypes.name}
                </div>
              </span>
              <span
                style={{
                  fontSize: "12px",
                  fontWeight: "500",
                  display: "flex",
                  marginBottom: ".2rem",
                }}
              >
                <div style={{ marginRight: ".3rem" }}>Block:</div>
                <div style={{ fontWeight: "300" }}>
                  {props.action.blockLibrary && props.action.blockLibrary.name}
                </div>
              </span>
            </div>
          )}
          {/* {props.program && props.program.name.length > 0 ? (
            <p>{props.program.name}</p>
          ) : (
            <>Action editor</>
          )} */}
        </div>
      </div>
      {props.action && (
        <div className="action-desc">{props.action.description}</div>
      )}
      <div className="action-icons">
        <ActionButton
          icon={<SaveIcon />}
          onClick={props.onSave && props.onSave}
        />
        <ActionButton onClick={props.undo} icon={<UndoIcon />} />
        <ActionButton onClick={props.redo} icon={<RedoIcon />} />
      </div>
    </div>
  );
};
export default ActionSidebar;
